import graph from "@irati/utils/services/graph";
import setIfNotSet from "@irati/utils/setIfNotSet";
import { toString as tenantQuery } from "./queries/Tenant";
import globalErrorHandler from "./errroHandlers/global";
var knownTenants = {};
export function getGlobalTenant(subdomain, options) {
    if (options === void 0) { options = {}; }
    if (!knownTenants[subdomain]) {
        var variables = { subdomain: subdomain };
        setIfNotSet(options, "ignoreMaintenance", true);
        options.unAuth = true;
        knownTenants[subdomain] = graph({ query: tenantQuery, variables: variables }, options)
            // toggle region
            .catch(globalErrorHandler)
            // if we still fail, clear knownTenant to allow retry
            .catch(function (err) {
            delete knownTenants[subdomain];
            throw err;
        })
            .then(function (data) { return data.globalTenant; });
    }
    return knownTenants[subdomain];
}
export default {
    getGlobalTenant: getGlobalTenant
};
